import axios from 'axios';
import BaseAPI from './base/base-api';

class OutInvoiceAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'outinvoices';

}

export default new OutInvoiceAPI();